/**
 * How long a read stays fresh, where the app-wide default is the wrong answer.
 *
 * The default in `query-client.ts` is a minute, and it is right for the things a
 * colleague changes while you are looking at them: a roster, a marking grid, a
 * register. It is the wrong unit for the school's own configuration — the grade
 * levels it runs, the identifiers it issues, the years it has set up, whether it
 * runs the gradebook at all. Those change when an admin visits Settings, which
 * is to say a handful of times a year.
 *
 * The cost of getting it wrong is not one request. These are the reads mounted
 * by the sidebar and by every form with a grade picker, so at a minute they are
 * on the critical path of *every* navigation, all day, ahead of the page the
 * person actually asked for.
 *
 * Raising it never delays a write. `invalidateQueries` marks an entry stale
 * whatever its staleTime says, and refetches it there and then if anything is
 * watching — which is exactly what `lib/cacheSync.ts` does on every write that
 * touches one of these. Freshness only decides what happens when nothing has
 * changed.
 *
 * This module deliberately holds a number and no imports, so a hook can name the
 * policy without pulling in the client the app happens to configure with it.
 */
export const REFERENCE_DATA_STALE_TIME = 5 * 60 * 1000
